import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    address,
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    date,
    taxAgencyName,
    period,
    resolutions,
    taxId,
    taxId2,
    taxpayerName,
    timeSign,
    taxAgentContract,
  },
} = checkout;

const validation = Yup.object().shape({
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [date.name]: Yup.string().required(date.errorMsg),
  [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [period.name]: Yup.number().required(period.errorMsg),
  [resolutions.name]: Yup.number().required(resolutions.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
